(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.pauseBtn = this.querySelector('[data-announcement-pause]');
      if (this.slides[0]) this.slides[0].classList.add('is-active');
      if (this.slides.length < 2) return;

      this.index = 0;
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.paused = this.reduce;

      this.start = this.start.bind(this);
      this.stop = this.stop.bind(this);

      // Pause on hover and keyboard focus (covers mouse, touch and keyboard).
      this.addEventListener('mouseenter', this.stop);
      this.addEventListener('mouseleave', () => { if (!this.userPaused) this.start(); });
      this.addEventListener('focusin', this.stop);
      this.addEventListener('focusout', () => { if (!this.userPaused) this.start(); });

      if (this.pauseBtn) {
        this.pauseBtn.addEventListener('click', () => this.toggle());
      }

      // Theme editor: pause rotation and reveal the selected message.
      if (window.Shopify && Shopify.designMode) {
        this.addEventListener('shopify:block:select', (e) => {
          this.stop();
          const slide = e.target.closest('[data-slide]');
          if (slide) this.show(this.slides.indexOf(slide));
        });
        this.addEventListener('shopify:block:deselect', () => { if (!this.userPaused) this.start(); });
      }

      if (!this.paused) this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      if (this.timer || this.reduce) return;
      this.timer = window.setInterval(() => this.next(), this.interval);
    }

    stop() {
      window.clearInterval(this.timer);
      this.timer = null;
    }

    toggle() {
      this.userPaused = !this.userPaused;
      this.pauseBtn.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
      const label = this.pauseBtn.querySelector('[data-pause-label]');
      if (label) {
        label.textContent = this.userPaused ? this.pauseBtn.dataset.labelPlay : this.pauseBtn.dataset.labelPause;
      }
      if (this.userPaused) { this.stop(); } else { this.start(); }
    }

    show(index) {
      this.slides[this.index].classList.remove('is-active');
      this.index = index;
      this.slides[this.index].classList.add('is-active');
    }

    next() {
      this.show((this.index + 1) % this.slides.length);
    }
  }
  if (!customElements.get('announcement-bar')) customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["appointment"]) return;
  try {
    
  (function () {
    var input = document.querySelector('[data-appointment-piece]');
    if (!input) return;
    var piece = new URLSearchParams(window.location.search).get('piece');
    if (piece) input.value = piece;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    var btn = document.querySelector('[data-article-share]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var data = { title: document.title, url: window.location.href };
      if (navigator.share) { navigator.share(data).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText(window.location.href).catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.changeUrl = this.dataset.changeUrl;
      this.updateUrl = this.dataset.updateUrl;
      this.addUrl = this.dataset.addUrl;
      this.upsellHTML = '';
      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.refreshHandler = () => this.refresh();
      this.onDocClick = (e) => {
        if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); this.open(); }
      };
      this.onDocKeydown = (e) => {
        if (this.dataset.open !== 'true') return;
        if (e.key === 'Escape') { this.close(); return; }
        window.WMFocusTrap.handle(this, e);
      };

      document.addEventListener('click', this.onDocClick);
      document.addEventListener('cart:open', this.open);
      document.addEventListener('cart:refresh', this.refreshHandler);
      document.addEventListener('keydown', this.onDocKeydown);

      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('change', (e) => this.onChange(e));
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('cart:open', this.open);
      document.removeEventListener('cart:refresh', this.refreshHandler);
      document.removeEventListener('keydown', this.onDocKeydown);
    }

    open() {
      this.trigger = document.activeElement;
      this.loadUpsell();
      this.dataset.open = 'true';
      this.removeAttribute('inert');
      document.querySelectorAll('[data-cart-toggle]').forEach((el) => el.setAttribute('aria-expanded', 'true'));
      document.documentElement.style.overflow = 'hidden';
      const focusTarget = this.querySelector('.cart-drawer__head [data-cart-close]');
      if (focusTarget) window.setTimeout(() => focusTarget.focus(), 120);
    }

    close() {
      this.dataset.open = 'false';
      this.setAttribute('inert', '');
      document.querySelectorAll('[data-cart-toggle]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
      document.documentElement.style.overflow = '';
      if (this.trigger && typeof this.trigger.focus === 'function') this.trigger.focus();
    }

    onClick(e) {
      if (e.target.closest('[data-cart-close]')) { this.close(); return; }

      const remove = e.target.closest('[data-qty-remove]');
      if (remove) { e.preventDefault(); this.updateQuantity(remove.dataset.key, 0); return; }

      const item = e.target.closest('[data-cart-item]');
      if (!item) return;
      const input = item.querySelector('[data-qty-input]');
      const current = parseInt(input.value, 10) || 0;
      if (e.target.closest('[data-qty-up]')) this.updateQuantity(input.dataset.key, current + 1);
      if (e.target.closest('[data-qty-down]')) this.updateQuantity(input.dataset.key, current - 1);
    }

    captureFocus() {
      const active = document.activeElement;
      if (!active || !this.contains(active)) return null;
      const item = active.closest('[data-cart-item]');
      if (!item) return null;
      let control = 'input';
      if (active.closest('[data-qty-up]')) control = 'up';
      else if (active.closest('[data-qty-down]')) control = 'down';
      else if (active.closest('[data-qty-remove]')) control = 'remove';
      return { key: item.dataset.key, control };
    }

    restoreFocus(target) {
      if (!target) return;
      const selectors = { up: '[data-qty-up]', down: '[data-qty-down]', remove: '[data-qty-remove]', input: '[data-qty-input]' };
      let item = this.querySelector(`[data-cart-item][data-key="${(window.CSS && CSS.escape ? CSS.escape(target.key) : target.key)}"]`);
      if (!item) item = this.querySelector('[data-cart-item]'); // line removed → nearest remaining item
      const el = item && item.querySelector(selectors[target.control] || selectors.input);
      if (el) { el.focus(); return; }
      const fallback = this.querySelector('.cart-drawer__head [data-cart-close]');
      if (fallback) fallback.focus();
    }

    onChange(e) {
      const note = e.target.closest('[data-cart-note]');
      if (note) { this.saveNote(note.value); return; }
      const input = e.target.closest('[data-qty-input]');
      if (!input) return;
      const qty = Math.max(0, parseInt(input.value, 10) || 0);
      this.updateQuantity(input.dataset.key, qty);
    }

    async saveNote(value) {
      try {
        await fetch(this.updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: value }),
        });
      } catch (_) { /* non-blocking */ }
    }

    // ---- Cross-sell: recommendations for the first cart line, excluding items already in the cart. ----
    async loadUpsell() {
      try {
        const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
        if (!cart.items.length) { this.upsellHTML = ''; this.injectUpsell(); return; }
        const inCart = new Set(cart.items.map((i) => i.product_id));
        // Locale-aware root (/en/…) so titles and links follow the active language.
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const res = await fetch(`${root}recommendations/products.json?product_id=${cart.items[0].product_id}&limit=8&intent=related`);
        if (!res.ok) return;
        const recos = (await res.json()).products.filter((p) => !inCart.has(p.id) && p.available).slice(0, 4);
        // Prices come back in the cart's (market) currency: format them in that currency, never a fixed €.
        const money = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: cart.currency || 'EUR' });
        this.upsellHTML = recos.map((p) => {
          const img = (p.featured_image || (p.images && p.images[0]) || '');
          const src = img ? `${img}${img.includes('?') ? '&' : '?'}width=320` : '';
          const price = typeof p.price === 'number' ? money.format(p.price / 100) : p.price;
          return `<a class="cart-drawer__upsell-card" href="${p.url}">
            ${src ? `<img src="${src}" alt="" loading="lazy" width="160" height="160">` : ''}
            <span class="cart-drawer__upsell-name">${p.title}</span>
            <span class="cart-drawer__upsell-price">${price}</span>
          </a>`;
        }).join('');
        this.injectUpsell();
      } catch (_) { /* upsell is a bonus, never block the cart */ }
    }

    injectUpsell() {
      const wrap = this.querySelector('[data-cart-upsell]');
      const row = this.querySelector('[data-cart-upsell-row]');
      if (!wrap || !row) return;
      if (this.upsellHTML) { row.innerHTML = this.upsellHTML; wrap.hidden = false; }
      else { row.innerHTML = ''; wrap.hidden = true; }
    }

    async updateQuantity(key, quantity) {
      const focus = this.captureFocus();
      this.setAttribute('data-loading', '');
      try {
        const response = await fetch(this.changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: this.sectionId, sections_url: window.location.pathname }),
        });
        let data = null;
        try { data = await response.json(); } catch (_) { data = null; }
        if (!response.ok || !data) { await this.refreshContents(); return; }
        this.render(data);
      } catch (_) {
        await this.refreshContents();
      } finally {
        this.removeAttribute('data-loading');
        this.restoreFocus(focus);
      }
    }

    async refreshContents() {
      try {
        const response = await fetch(`${window.location.pathname}?section_id=${this.sectionId}`);
        if (response.ok) this.replaceContents(await response.text());
      } catch (_) {
        /* leave current DOM untouched on failure */
      }
    }

    async refresh() {
      await this.refreshContents();
      this.open();
    }

    render(data) {
      if (data.sections && data.sections[this.sectionId]) {
        this.replaceContents(data.sections[this.sectionId]);
      }
      if (typeof data.item_count === 'number') this.syncCount(data.item_count);
      this.announce();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    }

    announce() {
      const status = this.querySelector('[data-cart-status]');
      if (!status) return;
      const message = status.getAttribute('data-updated') || '';
      // Re-set to the same text so assistive tech reliably re-announces it.
      status.textContent = '';
      window.setTimeout(() => { status.textContent = message; }, 60);
    }

    replaceContents(html) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('[data-cart-contents]');
      const current = this.querySelector('[data-cart-contents]');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const freshCount = parsed.querySelector('[data-cart-count]');
      if (freshCount) this.syncCount(parseInt(freshCount.textContent, 10) || 0);
      // The re-render wipes the upsell row; re-inject then refresh it (cart lines changed).
      this.injectUpsell();
      this.loadUpsell();
    }

    syncCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.classList.toggle('is-visible', count > 0);
      });
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  class CartPage extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.changeUrl = this.dataset.changeUrl;
      this.status = this.querySelector('[data-cart-status]');
      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('change', (e) => this.onChange(e));
    }

    onClick(e) {
      const remove = e.target.closest('[data-qty-remove]');
      if (remove) { e.preventDefault(); this.update(remove.dataset.key, 0); return; }
      const item = e.target.closest('[data-cart-item]');
      if (!item) return;
      const input = item.querySelector('[data-qty-input]');
      const current = parseInt(input.value, 10) || 0;
      if (e.target.closest('[data-qty-up]')) this.update(input.dataset.key, current + 1);
      if (e.target.closest('[data-qty-down]')) this.update(input.dataset.key, current - 1);
    }

    onChange(e) {
      const input = e.target.closest('[data-qty-input]');
      if (!input) return;
      this.update(input.dataset.key, Math.max(0, parseInt(input.value, 10) || 0));
    }

    captureFocus() {
      const active = document.activeElement;
      if (!active || !this.contains(active)) return null;
      const item = active.closest('[data-cart-item]');
      if (!item) return null;
      let control = 'input';
      if (active.closest('[data-qty-up]')) control = 'up';
      else if (active.closest('[data-qty-down]')) control = 'down';
      else if (active.closest('[data-qty-remove]')) control = 'remove';
      return { key: item.dataset.key, control };
    }

    restoreFocus(target) {
      if (!target) return;
      const selectors = { up: '[data-qty-up]', down: '[data-qty-down]', remove: '[data-qty-remove]', input: '[data-qty-input]' };
      let item = this.querySelector(`[data-cart-item][data-key="${(window.CSS && CSS.escape ? CSS.escape(target.key) : target.key)}"]`);
      if (!item) item = this.querySelector('[data-cart-item]'); // line removed → nearest remaining item
      const el = item && item.querySelector(selectors[target.control] || selectors.input);
      if (el) el.focus();
    }

    announce() {
      if (!this.status) return;
      const message = this.status.getAttribute('data-updated') || '';
      // Clear then re-set so assistive tech reliably re-announces repeat updates.
      this.status.textContent = '';
      window.setTimeout(() => { this.status.textContent = message; }, 60);
    }

    async update(key, quantity) {
      const focus = this.captureFocus();
      this.setAttribute('data-loading', '');
      try {
        const response = await fetch(this.changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity, sections: this.sectionId, sections_url: window.location.pathname }),
        });
        let data = null;
        try { data = await response.json(); } catch (_) { data = null; }
        if (response.ok && data && data.sections && data.sections[this.sectionId]) {
          this.replaceContents(data.sections[this.sectionId]);
          if (typeof data.item_count === 'number') this.syncCount(data.item_count);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
          this.announce();
        }
      } finally {
        this.removeAttribute('data-loading');
        this.restoreFocus(focus);
      }
    }

    replaceContents(html) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('[data-cart-contents]');
      const current = this.querySelector('[data-cart-contents]');
      if (!fresh || !current) return;
      // Carry over an unsaved gift note (only persisted on checkout submit) so
      // an AJAX quantity change never wipes what the customer just typed.
      const note = current.querySelector('textarea[name="note"]');
      const typed = note && note.value;
      const wasOpen = note && note.closest('details') && note.closest('details').open;
      current.innerHTML = fresh.innerHTML;
      if (typed) {
        const freshNote = current.querySelector('textarea[name="note"]');
        if (freshNote) {
          freshNote.value = typed;
          if (wasOpen && freshNote.closest('details')) freshNote.closest('details').open = true;
        }
      }
    }

    syncCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.classList.toggle('is-visible', count > 0);
      });
    }
  }
  if (!customElements.get('cart-page')) customElements.define('cart-page', CartPage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-main"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
    var loadedAt = Date.now();
    var hp = form.querySelector('[data-contact-hp]');
    form.addEventListener('submit', function (e) {
      // Block if the honeypot was filled (bot) or the form was submitted suspiciously fast (< 3s).
      if ((hp && hp.value) || Date.now() - loadedAt < 3000) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["email-popup"]) return;
  try {
    
    class EmailPopup extends HTMLElement {
      connectedCallback() {
        this.KEY = 'wm_welcome_popup_v1';
        if (this.dismissed()) return;
        this.card = this.querySelector('.email-popup__card');
        this.form = this.querySelector('[data-ep-form]');
        this.querySelectorAll('[data-ep-close]').forEach((el) => el.addEventListener('click', () => this.close()));
        this.onKey = (e) => { if (e.key === 'Escape') this.close(); };

        this.timer = window.setTimeout(() => this.open(), parseInt(this.dataset.delay, 10) || 8000);
        this.onExit = (e) => { if (e.clientY <= 0) this.open(); };
        document.addEventListener('mouseout', this.onExit);

        if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));
      }
      dismissed() { try { return !!localStorage.getItem(this.KEY); } catch (_) { return false; } }
      remember() { try { localStorage.setItem(this.KEY, Date.now()); } catch (_) {} }
      open() {
        if (this.opened || this.dismissed()) return;
        // Don't stack on top of the cookie-consent banner (it would cover the
        // email field). Wait until the visitor has accepted/refused cookies.
        const consent = document.querySelector('#shopify-pc__banner');
        if (consent && consent.offsetParent !== null) {
          if (!this._consentPoll) {
            this._consentPoll = window.setInterval(() => {
              const c = document.querySelector('#shopify-pc__banner');
              if (!c || c.offsetParent === null) {
                window.clearInterval(this._consentPoll);
                this._consentPoll = null;
                this.open();
              }
            }, 1000);
          }
          return;
        }
        this.opened = true;
        window.clearTimeout(this.timer);
        document.removeEventListener('mouseout', this.onExit);
        this.hidden = false;
        requestAnimationFrame(() => this.classList.add('is-open'));
        document.addEventListener('keydown', this.onKey);
        const email = this.querySelector('#ep-email');
        if (email) window.setTimeout(() => email.focus(), 200);
      }
      close() {
        this.remember();
        this.classList.remove('is-open');
        document.removeEventListener('keydown', this.onKey);
        window.setTimeout(() => { this.hidden = true; }, 300);
      }
      async onSubmit(e) {
        e.preventDefault();
        const btn = this.querySelector('[data-ep-submit]');
        if (btn) btn.disabled = true;
        try {
          await fetch(window.location.pathname, { method: 'POST', body: new FormData(this.form) });
        } catch (_) { /* signup is best-effort; still show success */ }
        this.remember();
        this.querySelector('[data-ep-form-state]').hidden = true;
        this.querySelector('[data-ep-success]').hidden = false;
        document.dispatchEvent(new CustomEvent('wm:newsletter-signup'));
      }
    }
    if (!customElements.get('email-popup')) customElements.define('email-popup', EmailPopup);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.track) return;
      this.onScroll = () => this.updateButtons();
      this.onPrev = () => this.scroll(-1);
      this.onNext = () => this.scroll(1);
      if (this.prev) this.prev.addEventListener('click', this.onPrev);
      if (this.next) this.next.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateButtons());
        this.resizeObserver.observe(this.track);
      }
      this.updateButtons();
    }

    disconnectedCallback() {
      if (this.prev) this.prev.removeEventListener('click', this.onPrev);
      if (this.next) this.next.removeEventListener('click', this.onNext);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    step() {
      const item = this.track.querySelector('.featured__item');
      return item ? item.getBoundingClientRect().width + 16 : this.track.clientWidth * 0.8;
    }

    scroll(direction) {
      this.track.scrollBy({ left: this.step() * direction * 2, behavior: 'smooth' });
    }

    updateButtons() {
      if (!this.prev || !this.next) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max;
    }
  }
  if (!customElements.get('product-carousel')) customElements.define('product-carousel', ProductCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.transparent = this.dataset.transparent === 'true';
      this.threshold = 40;
      this.onScroll = this.onScroll.bind(this);
      if (this.transparent) {
        const bar = document.querySelector('announcement-bar');
        const setOffset = () => this.style.setProperty('--ann-h', (bar ? bar.offsetHeight : 0) + 'px');
        setOffset();
        window.addEventListener('resize', setOffset, { passive: true });
      }
      // Scroll listener on every page so the header can shed a few px (compact).
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
      initMegaMenus(this);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      this.classList.toggle('is-solid', window.scrollY > this.threshold);
    }
  }
  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  /* Single source of truth for the desktop mega-menus. Because the panel lives
     inside its <li> (via .header__mega-hit-area, which overlaps the link with no
     gap), moving from the link to the submenu never leaves the item, so no
     pointerleave fires between them. Opening is instant; closing waits 350ms and
     is cancelled the moment the pointer returns to the link OR the submenu.
     Idempotent per item so re-runs (theme editor reloads) never double-bind. */
  function initMegaMenus(root) {
    const CLOSE_DELAY = 350;
    (root || document).querySelectorAll('.header__nav-item--has-mega').forEach((item) => {
      if (item.dataset.megaInitialized === 'true') return;
      item.dataset.megaInitialized = 'true';

      let closeTimer = 0;
      const open = () => { window.clearTimeout(closeTimer); item.classList.add('is-open'); };
      const close = () => {
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => item.classList.remove('is-open'), CLOSE_DELAY);
      };
      const closeIfLeft = (e) => { if (!item.contains(e.relatedTarget)) close(); };

      item.addEventListener('pointerenter', open);
      item.addEventListener('pointerleave', closeIfLeft);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', closeIfLeft);
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { window.clearTimeout(closeTimer); item.classList.remove('is-open'); }
      });
    });
  }

  if (!window.__wmMegaMenuBound) {
    window.__wmMegaMenuBound = true;
    document.addEventListener('shopify:section:load', () => initMegaMenus(document));
  }

  class NavDrawer extends HTMLElement {
    connectedCallback() {
      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onDocClick = (e) => {
        if (e.target.closest('[data-nav-toggle]')) { e.preventDefault(); this.open(); }
        if (e.target.closest('[data-nav-close]')) this.close();
      };

      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    onKeydown(e) {
      if (this.dataset.open !== 'true') return;
      if (e.key === 'Escape') { this.close(); return; }
      window.WMFocusTrap.handle(this, e);
    }

    open() {
      this.trigger = document.activeElement;
      this.dataset.open = 'true';
      this.removeAttribute('inert');
      document.querySelectorAll('[data-nav-toggle]').forEach((el) => el.setAttribute('aria-expanded', 'true'));
      document.documentElement.style.overflow = 'hidden';
      const first = window.WMFocusTrap.focusable(this)[0];
      if (first) window.setTimeout(() => first.focus(), 120);
    }

    close() {
      this.dataset.open = 'false';
      this.setAttribute('inert', '');
      document.querySelectorAll('[data-nav-toggle]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
      document.documentElement.style.overflow = '';
      if (this.trigger && typeof this.trigger.focus === 'function') this.trigger.focus();
    }
  }
  if (!customElements.get('nav-drawer')) customElements.define('nav-drawer', NavDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Desktop dropdown behaviour: open one facet menu closes the others, and a
     click outside (or Escape) closes any open menu. Scoped to this element so
     the search page's sidebar facets are untouched. */
  class FacetDropdowns extends HTMLElement {
    connectedCallback() {
      this.desktop = window.matchMedia('(min-width: 60em)');

      // Facets arrive as <details open>; collapse them on desktop so they read as
      // closed dropdown menus, then reveal the controller (unhides the popovers).
      this.collapseForDesktop();
      this.setAttribute('data-ready', '');

      this.onToggle = (e) => {
        const group = e.target;
        if (!(group instanceof HTMLDetailsElement) || !group.open) return;
        if (!this.desktop.matches) return;
        this.querySelectorAll('details.facets__group[open]').forEach((d) => {
          if (d !== group) d.open = false;
        });
      };
      // `toggle` doesn't bubble, so listen in the capture phase.
      this.addEventListener('toggle', this.onToggle, true);

      this.onDocClick = (e) => {
        if (!this.desktop.matches) return;
        if (this.contains(e.target) && e.target.closest('details.facets__group')) return;
        this.closeAll();
      };
      this.onKey = (e) => { if (e.key === 'Escape') this.closeAll(); };
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);

      // AJAX re-renders the facet groups (again as <details open>) — recollapse.
      const groups = this.querySelector('[data-facet-groups]');
      if (groups) {
        this.observer = new MutationObserver(() => this.collapseForDesktop());
        this.observer.observe(groups, { childList: true });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
      if (this.observer) this.observer.disconnect();
    }

    collapseForDesktop() {
      if (!this.desktop.matches) return;
      this.closeAll();
    }

    closeAll() {
      this.querySelectorAll('details.facets__group[open]').forEach((d) => { d.open = false; });
    }
  }
  if (!customElements.get('facet-dropdowns')) customElements.define('facet-dropdowns', FacetDropdowns);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      const data = this.querySelector('[data-product-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];
      this.addUrl = this.dataset.cartAddUrl;

      this.priceWrapper = this.querySelector('[data-price-wrapper]');
      this.priceEl = this.querySelector('[data-price]');
      this.compareEl = this.querySelector('[data-compare]');
      this.addButton = this.querySelector('[data-add-button]');
      this.addText = this.querySelector('[data-add-text]');
      this.errorEl = this.querySelector('[data-add-error]');
      this.soldOutCta = this.querySelector('[data-sold-out-cta]');
      this.sizeRequest = this.querySelector('[data-size-request]');
      this.productTitle = this.dataset.productTitle || '';
      this.waNumber = '33756849413';

      this.idInput = this.form.querySelector('input[name="id"]');
      if (!this.idInput) {
        this.idInput = document.createElement('input');
        this.idInput.type = 'hidden';
        this.idInput.name = 'id';
        this.form.appendChild(this.idInput);
      }

      this.optionInputs = Array.from(this.querySelectorAll('[data-option-value]'));
      this.optionInputs.forEach((i) => i.addEventListener('change', () => this.onOptionChange()));

      this.addEventListener('click', (e) => this.onQuantityClick(e));

      const engravingInput = this.querySelector('[data-engraving-input]');
      const engravingCount = this.querySelector('[data-engraving-count]');
      if (engravingInput && engravingCount) {
        engravingInput.addEventListener('input', () => { engravingCount.textContent = engravingInput.value.length; });
      }

      this.statusEl = this.querySelector('[data-add-status]');
      this.stickyBar = this.querySelector('[data-sticky-bar]');
      this.stickyAdd = this.querySelector('[data-sticky-add]');
      this.stickyPrice = this.querySelector('[data-sticky-price]');
      if (this.stickyAdd) this.stickyAdd.addEventListener('click', () => { if (this.addButton) this.addButton.click(); });
      if (this.stickyBar && this.addButton && 'IntersectionObserver' in window) {
        this.stickyObserver = new IntersectionObserver((entries) => {
          this.stickyBar.classList.toggle('is-visible', !entries[0].isIntersecting);
        }, { rootMargin: '0px 0px -40% 0px' });
        this.stickyObserver.observe(this.addButton);
      }

      this.form.addEventListener('submit', (e) => this.onSubmit(e));

      // Start from the options actually checked: they may have been changed (or restored by the
      // browser) before this script ran, and the posted id must always match what is displayed.
      const initial = this.optionInputs.length
        ? this.variantFromSelection()
        : this.variantFromUrl() || this.variants.find((v) => v.available) || this.variants[0];
      this.update(initial || null, false);
      if (this.addButton) this.addButton.dataset.state = 'idle'; // ready: leave the server-rendered pending state
    }

    disconnectedCallback() {
      if (this.stickyObserver) this.stickyObserver.disconnect();
    }

    variantFromUrl() {
      const id = new URLSearchParams(window.location.search).get('variant');
      return id ? this.variants.find((v) => String(v.id) === id) : null;
    }

    selectedValues() {
      const values = [];
      this.optionInputs.filter((i) => i.checked).forEach((i) => {
        values[parseInt(i.dataset.optionPosition, 10) - 1] = i.value;
      });
      return values;
    }

    variantFromSelection() {
      const values = this.selectedValues();
      return this.variants.find((v) => v.options.every((opt, i) => opt === values[i])) || null;
    }

    onOptionChange() {
      this.update(this.variantFromSelection(), true);
    }

    onQuantityClick(e) {
      const input = this.querySelector('[data-qty-input]');
      if (!input) return;
      const qty = parseInt(input.value, 10) || 1;
      if (e.target.closest('[data-qty-up]')) input.value = qty + 1;
      if (e.target.closest('[data-qty-down]')) input.value = Math.max(1, qty - 1);
    }

    update(variant, pushState) {
      this.current = variant;
      if (this.errorEl) this.errorEl.hidden = true;
      this.querySelectorAll('[data-option-index]').forEach((group) => {
        const checked = group.querySelector('[data-option-value]:checked');
        const label = group.querySelector('[data-option-selected]');
        if (checked && label) label.textContent = checked.dataset.optionLabel || checked.value;
      });
      this.updateAvailability();

      if (!variant) {
        this.idInput.value = ''; // never leave the previous variant's id behind for the dynamic checkout
        if (this.addButton) { this.addButton.disabled = true; this.addText.textContent = this.addButton.dataset.soldLabel; }
        if (this.stickyAdd) this.stickyAdd.disabled = true;
        if (this.soldOutCta) this.soldOutCta.hidden = false; // unselectable combination → offer the reassurance CTA
        if (this.errorEl) this.showError(this.errorEl.dataset.unavailable);
        this.refreshSizeRequest(false);
        return;
      }

      this.idInput.value = variant.id;

      if (this.priceEl) this.priceEl.textContent = variant.price;
      if (this.stickyPrice) this.stickyPrice.textContent = variant.price;
      if (this.compareEl) {
        if (variant.compare_at) {
          this.compareEl.textContent = variant.compare_at;
          this.compareEl.hidden = false;
          if (this.priceWrapper) this.priceWrapper.classList.add('price--on-sale');
        } else {
          this.compareEl.hidden = true;
          if (this.priceWrapper) this.priceWrapper.classList.remove('price--on-sale');
        }
      }

      if (this.addButton) {
        this.addButton.disabled = !variant.available;
        this.addText.textContent = variant.available ? this.addButton.dataset.addLabel : this.addButton.dataset.soldLabel;
        if (this.statusEl) this.statusEl.textContent = variant.available ? this.addButton.dataset.addLabel : this.addButton.dataset.soldLabel;
      }
      if (this.stickyAdd) this.stickyAdd.disabled = !variant.available;
      if (this.soldOutCta) this.soldOutCta.hidden = variant.available;
      this.refreshSizeRequest(variant.available);

      // Only jump the gallery to the variant's media on an explicit user change.
      if (variant.media_id && pushState) {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { mediaId: variant.media_id } }));
      }

      if (pushState) {
        const url = new URL(window.location);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    refreshSizeRequest(available) {
      if (!this.sizeRequest) return;
      const opts = this.optionInputs
        .filter((i) => i.checked)
        .map((i) => i.dataset.optionLabel || i.value);
      const detail = opts.length ? ' — ' + opts.join(', ') : '';
      const msg = available
        ? `Bonjour, je souhaite la ${this.productTitle}${detail} dans un autre carat. Est-ce possible ?`
        : `Bonjour, je souhaite la ${this.productTitle}${detail}. Est-elle disponible dans cette combinaison ?`;
      const label = this.sizeRequest.querySelector('[data-request-label]');
      const text = available
        ? this.sizeRequest.dataset.labelAvailable
        : this.sizeRequest.dataset.labelSoldout;
      if (label && text) label.textContent = text;
      this.sizeRequest.classList.toggle('buy-buttons__request--soft', available);
      this.sizeRequest.href = `https://wa.me/${this.waNumber}?text=${encodeURIComponent(msg)}`;
      this.sizeRequest.hidden = false;
    }

    updateAvailability() {
      if (!this.optionInputs.length) return;
      const selected = this.selectedValues();
      this.optionInputs.forEach((input) => {
        const pos = parseInt(input.dataset.optionPosition, 10) - 1;
        const candidate = selected.slice();
        candidate[pos] = input.value;
        const match = this.variants.find((v) => v.options.every((opt, i) => opt === candidate[i]));
        const available = !!(match && match.available);
        const label = this.querySelector(`label[for="${input.id}"]`);
        if (label) label.classList.toggle('variant-picker__pill--unavailable', !available);
      });
    }

    async onSubmit(e) {
      // Never let the form fall through to a native POST: it is the AJAX request or nothing.
      e.preventDefault();
      if (this.addButton && this.addButton.dataset.state === 'loading') return;
      if (!this.current || !this.current.available || !this.idInput.value) {
        if (this.errorEl) this.showError(this.errorEl.dataset.unavailable);
        return;
      }
      const qtyInput = this.querySelector('[data-qty-input]');
      if (qtyInput && !(parseInt(qtyInput.value, 10) >= 1)) qtyInput.value = 1;
      this.setAddState('loading');
      if (this.errorEl) this.errorEl.hidden = true;
      try {
        const response = await fetch(this.addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(this.form),
        });
        let data = null;
        try { data = await response.json(); } catch (_) { data = null; }
        if (!response.ok) {
          this.showError(data && (data.description || data.message));
          this.setAddState('idle');
          return;
        }
        this.setAddState('added');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.setTimeout(() => this.setAddState('idle'), 1200);
      } catch (_) {
        this.showError(this.errorEl ? this.errorEl.dataset.generic : '');
        this.setAddState('idle');
      }
    }

    setAddState(state) {
      if (!this.addButton) return;
      this.addButton.dataset.state = state;
      const available = this.current ? this.current.available : false;
      this.addButton.disabled = state === 'loading' || !available;
      if (this.stickyAdd) this.stickyAdd.disabled = state === 'loading' || !available;
      if (this.addText) {
        if (state === 'added') this.addText.textContent = this.addButton.dataset.addedLabel || this.addButton.dataset.addLabel;
        else this.addText.textContent = available ? this.addButton.dataset.addLabel : this.addButton.dataset.soldLabel;
      }
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || this.errorEl.dataset.generic;
      this.errorEl.hidden = false;
    }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moissanite-premium"] && !Shopify.designMode) return;
  try {
    
  class MoiDepth extends HTMLElement {
    connectedCallback() {
      this.stone = this.querySelector('[data-moi-stone]');
      if (!this.stone) return;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.reduce.matches) return; // CSS shows it static

      this.amp = this.amplitude();
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => this.update());
      };
      this.onResize = () => { this.amp = this.amplitude(); this.update(); };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    amplitude() {
      const w = window.innerWidth;
      if (w < 768) return null;                                        // mobile — static (no sticky)
      if (w < 1024) return { x: 46, scaleMax: 1.09, scaleEnd: 0.92 };  // tablet — intermediate
      return { x: 72, scaleMax: 1.12, scaleEnd: 0.9 };                 // desktop — full
    }

    update() {
      this.ticking = false;
      if (!this.amp) { this.stone.style.transform = ''; this.stone.style.opacity = ''; this.stone.style.filter = ''; return; }
      const rect = this.getBoundingClientRect();
      const vh = window.innerHeight;
      const span = rect.height - vh;
      let p = span > 0 ? -rect.top / span : 0;
      if (p < 0) p = 0; else if (p > 1) p = 1;

      const peak = Math.sin(Math.PI * p);            // 0 -> 1 -> 0
      const ease = (k) => (k < 0.5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2);
      const a = this.amp;

      let s;
      if (p <= 0.5) s = 0.82 + (a.scaleMax - 0.82) * ease(p / 0.5);
      else s = a.scaleMax + (a.scaleEnd - a.scaleMax) * ease((p - 0.5) / 0.5);

      const x = (a.x * (1 - peak)).toFixed(1);
      const op = (0.75 + 0.25 * peak).toFixed(3);
      const br = (0.92 + 0.14 * peak).toFixed(3);
      const ct = (1 + 0.06 * peak).toFixed(3);

      this.stone.style.transform = 'translate3d(' + x + 'px, 0, 0) scale(' + s.toFixed(3) + ')';
      this.stone.style.opacity = op;
      this.stone.style.filter = 'brightness(' + br + ') contrast(' + ct + ')';
    }
  }
  if (!customElements.get('moi-depth')) customElements.define('moi-depth', MoiDepth);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const observer = new IntersectionObserver((entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();
        this.load();
      }, { rootMargin: '0px 0px 400px 0px' });
      observer.observe(this);
    }

    async load() {
      try {
        const response = await fetch(this.dataset.url);
        if (!response.ok) return;
        const text = await response.text();
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const fresh = parsed.querySelector('product-recommendations');
        if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
      } catch (_) {
        /* leave empty on failure */
      }
    }
  }
  if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ring-sizer-print"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-print]')) window.print();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-hero"] && !Shopify.designMode) return;
  try {
    
  class HeroVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggle = this.querySelector('[data-hero-video-toggle]');
      if (!this.video) return;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.reduce.matches) this.play(); else this.pause();
      if (this.toggle) this.toggle.addEventListener('click', () => (this.video.paused ? this.play() : this.pause()));
    }
    play() { const p = this.video.play(); if (p && p.catch) p.catch(function () {}); this.removeAttribute('data-paused'); }
    pause() { this.video.pause(); this.setAttribute('data-paused', ''); }
  }
  if (!customElements.get('hero-video')) customElements.define('hero-video', HeroVideo);

  /* Very light parallax: the media drifts slower than the scroll while the hero
     is in view. Transform-only, rAF-throttled, and disabled under reduced motion. */
  class HeroParallax extends HTMLElement {
    connectedCallback() {
      this.depth = parseFloat(this.dataset.parallax || '0');
      if (!this.depth || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.hero = this.closest('.hero') || this;
      this.ticking = false;
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => this.update());
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }
    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
    }
    update() {
      this.ticking = false;
      const rect = this.hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return; // off-screen
      const shift = (rect.top * -this.depth).toFixed(1);
      this.style.transform = 'translate3d(0,' + shift + 'px,0)';
    }
  }
  if (!customElements.get('hero-parallax')) customElements.define('hero-parallax', HeroParallax);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsCarousel extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-tcar-viewport]');
      this.track = this.querySelector('[data-tcar-track]');
      this.prevBtn = this.querySelector('[data-tcar-prev]');
      this.nextBtn = this.querySelector('[data-tcar-next]');
      this.dotsWrap = this.querySelector('[data-tcar-dots]');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.real = Array.prototype.slice.call(this.track.children);
      this.realCount = this.real.length;
      if (!this.viewport || this.realCount === 0) return;
      this.animating = false;

      this.setup();

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(1));
      this.track.addEventListener('transitionend', (e) => { if (e.target === this.track) this.onEnd(); });
      this.addDrag();

      let t;
      window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(() => this.reconfigure(), 150); });
    }

    visibleCount() {
      const w = window.innerWidth;
      if (w >= 960) return 3;
      if (w >= 768) return 2;
      return 1;
    }

    clearClones() {
      const clones = this.track.querySelectorAll('[data-clone]');
      clones.forEach((n) => n.remove());
    }

    setup() {
      this.visible = this.visibleCount();
      this.clearClones();
      const makeClone = (node) => {
        const c = node.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-clone', '');
        c.querySelectorAll('a, button, [tabindex]').forEach((el) => el.setAttribute('tabindex', '-1'));
        return c;
      };
      const head = this.real.slice(-this.visible).map(makeClone);
      const tail = this.real.slice(0, this.visible).map(makeClone);
      head.forEach((n) => this.track.insertBefore(n, this.track.firstChild));
      tail.forEach((n) => this.track.appendChild(n));
      this.index = this.visible;
      this.buildDots();
      this.measure();
      this.place(false);
      this.updateDots();
    }

    measure() {
      const kids = this.track.children;
      if (kids.length < 2) { this.step = this.viewport.offsetWidth; return; }
      this.step = kids[1].getBoundingClientRect().left - kids[0].getBoundingClientRect().left;
    }

    place(animate) {
      this.track.style.transition = animate && !this.reduce.matches ? 'transform 420ms cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      this.track.style.transform = 'translate3d(' + (-this.index * this.step) + 'px, 0, 0)';
    }

    goTo(index) {
      if (this.animating) return;
      this.animating = true;
      this.index = index;
      this.place(true);
      this.updateDots();
      if (this.reduce.matches) this.onEnd();
    }
    go(dir) { this.goTo(this.index + dir); }

    onEnd() {
      this.animating = false;
      if (this.index >= this.realCount + this.visible) { this.index -= this.realCount; this.place(false); }
      else if (this.index < this.visible) { this.index += this.realCount; this.place(false); }
      this.updateDots();
    }

    buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      this.dots = [];
      for (let i = 0; i < this.realCount; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'tcar__dot';
        b.setAttribute('aria-label', 'Avis ' + (i + 1));
        b.addEventListener('click', () => this.goTo(this.visible + i));
        this.dotsWrap.appendChild(b);
        this.dots.push(b);
      }
    }
    updateDots() {
      if (!this.dots) return;
      let real = (this.index - this.visible) % this.realCount;
      if (real < 0) real += this.realCount;
      this.dots.forEach((d, i) => d.classList.toggle('is-active', i === real));
    }

    addDrag() {
      let startX = 0, base = 0, dragging = false, moved = 0;
      const down = (e) => {
        if (this.animating) return;
        dragging = true; moved = 0;
        startX = e.touches ? e.touches[0].clientX : e.clientX;
        base = -this.index * this.step;
        this.track.style.transition = 'none';
      };
      const move = (e) => {
        if (!dragging) return;
        const x = e.touches ? e.touches[0].clientX : e.clientX;
        moved = x - startX;
        this.track.style.transform = 'translate3d(' + (base + moved) + 'px, 0, 0)';
      };
      const up = () => {
        if (!dragging) return;
        dragging = false;
        const threshold = this.step * 0.2;
        if (moved <= -threshold) this.go(1);
        else if (moved >= threshold) this.go(-1);
        else this.place(true);
      };
      this.viewport.addEventListener('mousedown', down);
      window.addEventListener('mousemove', move);
      window.addEventListener('mouseup', up);
      this.viewport.addEventListener('touchstart', down, { passive: true });
      this.viewport.addEventListener('touchmove', move, { passive: true });
      this.viewport.addEventListener('touchend', up);
      this.viewport.addEventListener('dragstart', (e) => e.preventDefault());
    }

    reconfigure() {
      if (this.visibleCount() !== this.visible) this.setup();
      else { this.measure(); this.place(false); }
    }
  }
  if (!customElements.get('testimonials-carousel')) customElements.define('testimonials-carousel', TestimonialsCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"]) return;
  try {
    
  class WishlistList extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('[data-wishlist-grid]');
      this.empty = this.querySelector('[data-wishlist-empty]');
      this.actions = this.querySelector('[data-wishlist-actions]');
      this.section = this.dataset.section;
      this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      this.onChange = () => this.render();
      document.addEventListener('wishlist:change', this.onChange);
      this.render();
      const share = this.querySelector('[data-wishlist-share]');
      if (share) share.addEventListener('click', () => this.share());
    }

    disconnectedCallback() { document.removeEventListener('wishlist:change', this.onChange); }

    async render() {
      var token = (this.token = {});
      var self = this;
      var shared = new URLSearchParams(window.location.search).get('ids');
      var handles = shared ? shared.split(',').filter(Boolean) : (window.WMWishlist ? window.WMWishlist.items() : []);
      this.empty.hidden = handles.length > 0;
      this.actions.hidden = handles.length === 0;

      var htmls = await Promise.all(handles.map(function (h) {
        return fetch(self.root + 'products/' + encodeURIComponent(h) + '?section_id=' + self.section)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      }));
      if (token !== this.token) return; // superseded by a newer render

      this.grid.innerHTML = '';
      htmls.forEach(function (html) {
        if (!html) return;
        var card = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-wishlist-card]');
        if (card) self.grid.appendChild(card);
      });
    }

    share() {
      var handles = (window.WMWishlist ? window.WMWishlist.items() : []);
      var url = window.location.origin + window.location.pathname + (handles.length ? '?ids=' + encodeURIComponent(handles.join(',')) : '');
      if (navigator.share) { navigator.share({ url: url }).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText(url).catch(function () {});
    }
  }
  if (!customElements.get('wishlist-list')) customElements.define('wishlist-list', WishlistList);

  } catch(e) { console.error(e); }
})();
})();
